import { createStore } from 'vuex'
import login from './modules/login'
import sidebar from './modules/sidebar'
import account from './modules/account'
import task from './modules/task'
import object1 from './modules/object1'
import document from './modules/document'
import message from './modules/message'

const debug = process.env.NODE_ENV !== 'production'

export default createStore({

  modules: {
    login,
    sidebar,
    account,
    task,
    object1,
    document,
    message
  },
  strict: debug
  // plugins: debug ? [createLogger()] : []

})
